import React, { PureComponent } from "react";
import FileService from "../../services/fileService";
import MPSBarLoader from "../MPSBarLoader";
import ModalPopup from "../ModalPopup";
import { safePromise } from "../../utils/utils";

class ImageUrl extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
    this._isMounted = false;
    this.imageRequest = null;
  }

  componentDidMount() {
    this._isMounted = true;
    let { url } = this.props;
    this._isMounted = true;

    //console.log(`[ImageUrl] Component mounting with URL:`, url);
    this.setState({ loading: true });

    // Use the safePromise utility to safely handle state updates
    this.imageRequest = safePromise(
      FileService.getFile(url),
      this,
      (imageURL) => {
        if (imageURL) {
          //console.log(`[ImageUrl] Successfully loaded image:`, {
          //  originalUrl: url,
          //  imageURL,
          //});
          return { url: imageURL, loading: false };
        } else {
          console.warn(`ImageUrl: Failed to load image from URL: ${url}`);
          return { url: null, loading: false, loadError: true };
        }
      },
      (error) => {
        console.warn(`ImageUrl: Error loading image from URL: ${url}`, error);
        return { loading: false, loadError: true };
      }
    );
  }

  componentWillUnmount() {
    this._isMounted = false;
    // The safePromise utility handles cleanup automatically
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { url, loading, bigImage } = this.state;
    if (!url && !loading) {
      return null;
    }

    if (this.props.noSpinner && loading) {
      return null;
    }

    if (loading) {
      return (
        <div style={{ margin: "100px auto", width: 100 }}>
          <MPSBarLoader />
        </div>
      );
    }

    let { enablePreview } = this.props;

    return (
      <div
        className="imageUrl"
        style={{
          overflow: this.props.overflow || "hidden",
          cursor: enablePreview ? "pointer" : "",
        }}
        onClick={() => {
          if (enablePreview && this._isMounted) {
            this.setState({ bigImage: true });
          }
        }}
        // onMouseEnter={() => {
        //   if (enablePreview) {
        //
        //   }
        // }}
        // onMouseLeave={() => {
        //   if (enablePreview) {
        //     this.setState({ bigImage: false });
        //   }
        // }}
      >
        {bigImage && (
          <ModalPopup
            onClose={() => {
              if (this._isMounted) {
                this.setState({ bigImage: false });
              }
            }}
          >
            <div className="d-flex justify-content-center">
              <img
                alt="Image preview"
                src={this.state.url}
                height="100%"
                style={
                  this.props.imageStyle
                    ? this.props.imageStyle
                    : {
                        height: "350px",
                        // position: "absolute",
                        zIndex: 9999,
                        border: bigImage ? "1px solid #dddfe2" : "",
                        borderRadius: bigImage ? "4px" : "",
                      }
                }
              />
            </div>
          </ModalPopup>
        )}
        <img
          alt="Image preview"
          src={this.state.url}
          width={this.props.width}
          height={this.props.imgHeight}
          loading={this.props.loading}
          decoding={this.props.decoding}
          style={
            this.props.imageStyle
              ? this.props.imageStyle
              : { height: this.props.height, borderRadius: 4 }
          }
        />
      </div>
    );
  }
}

export default ImageUrl;
